// Copyright (c) Ensho Health, 2021 to present

import actions from '../action';
import dayjs from 'dayjs';

const defaultState = {
  list: [],
  detail: {},
  offset: 0,
  limit: 25,
  doReload: false,
  loading: false,
  error: null,
  orderingPhysicians: [],
  filters: {
    outcome: { label: 'Elevated Likelihood results only', value: 'abnormal' },
    algo: null,
    date: { start: null, end: null },
    timeFrame: { label: 'Past 3 months', value: 'Past 3 months' },
    orderingPhy: null
  }
};

export default function appReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.labResult.ACTION_TYPES.RESET_FILTERS:
      return {
        ...state,
        filters: {
          outcome: null,
          algo: null,
          date: { start: null, end: null },
          timeFrame: null,
          orderingPhy: null
        },
        offset: 0
      };
    case actions.labResult.ACTION_TYPES.SET_FILTERS:
      return {
        ...state,
        filters: action.payload,
        offset: 0
      };
    case actions.labResult.ACTION_TYPES.SET_ORDERING_PHY:
      return {
        ...state,
        orderingPhysicians: action.payload,
        loading: false
      };
    case actions.labResult.ACTION_TYPES.SET_LIST:
      let newList = [];
      if (state.offset === 0) {
        newList = [...action.payload];
      } else {
        newList = [...state.list, ...action.payload];
      }
      return {
        ...state,
        list: newList,
        loading: false,
        offset: action.payload.length + state.offset,
        doReload: false
      };
    case actions.labResult.ACTION_TYPES.SET_DETAIL:
      const updatedList = [...state.list];
      for (let listIndex = 0; listIndex < updatedList.length; listIndex++) {
        if (
          updatedList[listIndex].resultId === action.payload.resultId &&
          updatedList[listIndex].patientId === action.payload.patientId &&
          !updatedList[listIndex].seenOn
        ) {
          updatedList[listIndex].seenOn = dayjs().format('YYYY-MM-DD');
        }
      }
      return {
        ...state,
        list: updatedList,
        detail: action.payload,
        loading: false
      };
    case actions.labResult.ACTION_TYPES.RESET_OFFSET:
      let doReload = false;
      if (state.list.length > 0) {
        doReload = true;
      }
      return { ...state, offset: 0, list: [], doReload: doReload };
    case actions.labResult.ACTION_TYPES.ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case actions.labResult.ACTION_TYPES.LOADING:
      return { ...state, loading: true, error: null };
    default:
      return state;
  }
}
